var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistoricBusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 11.5067C21.4533 11.5067 21 11.0533 21 10.5067V8.66668C21 7.26668 20.4 5.90668 19.36 4.96001C18.3067 4.00001 16.9467 3.56001 15.5067 3.69335C13.1067 3.92001 11 6.37335 11 8.93335V10.2267C11 10.7733 10.5467 11.2267 10 11.2267C9.45333 11.2267 9 10.7733 9 10.2267V8.92001C9 5.33335 11.8933 2.02668 15.32 1.69335C17.32 1.50668 19.24 2.13335 20.7067 3.48001C22.16 4.80001 23 6.69335 23 8.66668V10.5067C23 11.0533 22.5467 11.5067 22 11.5067Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.3334H12C5.84 30.3334 4.69334 27.4667 4.4 24.68L3.4 16.6934C3.25334 15.2534 3.2 13.1867 4.6 11.64C5.8 10.3067 7.78667 9.66669 10.6667 9.66669H21.3333C24.2267 9.66669 26.2133 10.32 27.4 11.64C28.7867 13.1867 28.7467 15.2534 28.6 16.6667L27.6 24.68C27.3067 27.4667 26.16 30.3334 20 30.3334ZM10.6667 11.6667C8.41334 11.6667 6.86667 12.1067 6.08 12.9867C5.42667 13.7067 5.21334 14.8134 5.38667 16.4667L6.38667 24.4534C6.61334 26.5867 7.2 28.3467 12 28.3467H20C24.8 28.3467 25.3867 26.6 25.6133 24.48L26.6133 16.4667C26.7867 14.84 26.5733 13.7334 25.92 13C25.1333 12.1067 23.5867 11.6667 21.3333 11.6667H10.6667Z",
    fill: "#455CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.56 17.5333C19.8133 17.5333 19.2133 16.9333 19.2133 16.2C19.2133 15.4666 19.8133 14.8666 20.5467 14.8666C21.28 14.8666 21.88 15.4666 21.88 16.2C21.88 16.9333 21.2933 17.5333 20.56 17.5333Z",
    fill: "#455CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2267 17.5333C10.48 17.5333 9.88 16.9333 9.88 16.2C9.88 15.4666 10.48 14.8666 11.2133 14.8666C11.9467 14.8666 12.5467 15.4666 12.5467 16.2C12.5467 16.9333 11.96 17.5333 11.2267 17.5333Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoricBusiness);
export default __webpack_public_path__ + "static/media/HistoricBusiness.4b646c17.svg";
export { ForwardRef as ReactComponent };